import { Box, Text, VStack, Icon } from '@chakra-ui/react';
import { FiInbox } from 'react-icons/fi';

export const EmptyState = ({
  title = 'No items found',
  description = '',
  icon = FiInbox
}) => {
  return (
    <Box textAlign="center" py={10} px={6}>
      <VStack spacing={4}>
        <Icon as={icon} boxSize={12} color="gray.400" />
        <Text fontSize="xl" fontWeight="medium" color="gray.600">
          {title}
        </Text>
        {description && (
          <Text color="gray.500" maxW="md">
            {description}
          </Text>
        )}
      </VStack>
    </Box>
  );
};
